import React, { Component } from "react";

export class CopyRight extends Component {
  render() {
    const year = new Date().getFullYear();

    return (
      <>
        <section className="copyrightContainer">
          <div className="centerRight">
            <p className="copyRight">
              ©{year}{" "}
              <a href="/">Algoquant Global Private Limited</a>. All rights
              reserved.
            </p>
          </div>
        </section>
      </>
    );
  }
}

export default CopyRight;
